<article class="notificationsPanel__content">
  @if (ppExpanded) {
    <header class="notificationsPanel__header">
      <div class="notificationsPanel__title-container">
        <h4>Notifications</h4>
        <pp-notification-top-toolbar
          class="notificationToolbar"
          [ppAllNotificationsRead]="allNotificationsRead"
          (ppMarkAllAsRead)="markAllAsRead()"
          (ppFilter)="filterNotifications()"
        ></pp-notification-top-toolbar>
      </div>
      <pp-notification-mode-select
        (ppFirstChoice)="switchMode('all')"
        (ppSecondChoice)="switchMode('unread')"
        (ppThirdChoice)="switchMode('mentioned')"
        (ppFourthChoice)="switchMode('assigned')"
        [ppSelected]="
          notificationsMode.mode === 'all'
            ? 0
            : notificationsMode.mode === 'unread'
              ? 1
              : notificationsMode.mode === 'mentioned'
                ? 2
                : 3
        "
      ></pp-notification-mode-select>
    </header>
    <section class="notificationsPanel__body" (scroll)="onScroll($event)" #notifications>
      <div id="notificationsScroll" (ppOnRendered)="onScrollRendered()">
        @if (
          todayNotifications.length === 0 &&
          yesterdayNotifications.length === 0 &&
          olderNotifications.length === 0 &&
          !loading
          ) {
          <p
            class="notificationsPanel__no-notifications"
            >
            No notifications to display.
          </p>
        }
        @if (todayNotifications.length > 0) {
          <h6 class="notificationsPanel__day">TODAY</h6>
        }
        @for (notification of todayNotifications; track notification) {
          @if (workspaces && usersFetched) {
            <pp-notification
              [ppNotificationId]="notification.id"
              [ppDataFetched]="dataFetched"
              [ppAccountName]="workspaces[notification.workspaceId]?.accountName"
              [ppDateFormat]="format"
            ></pp-notification>
          }
        }
        @if (yesterdayNotifications.length > 0) {
          <div>
            <h6 class="notificationsPanel__day">YESTERDAY</h6>
            @for (notification of yesterdayNotifications; track notification) {
              @if (workspaces && usersFetched) {
                <pp-notification
                  [ppNotificationId]="notification.id"
                  [ppDataFetched]="dataFetched"
                  [ppAccountName]="workspaces[notification.workspaceId]?.accountName"
                  [ppDateFormat]="format"
                ></pp-notification>
              }
            }
          </div>
        }
        @if (olderNotifications.length > 0) {
          <div>
            <h6 class="notificationsPanel__day">OLDER</h6>
            @for (notification of olderNotifications; track notification) {
              @if (workspaces && usersFetched) {
                <pp-notification
                  [ppNotificationId]="notification.id"
                  [ppDataFetched]="dataFetched"
                  [ppAccountName]="workspaces[notification.workspaceId]?.accountName"
                  [ppDateFormat]="format"
                ></pp-notification>
              }
            }
          </div>
        }
        <div class="notifications__spinner-wrapper">
          @if (loading) {
            <pp-spinner class="notifications__spinner"></pp-spinner>
          }
          @if (
            !loading &&
            !(
            todayNotifications.length === 0 &&
            yesterdayNotifications.length === 0 &&
            olderNotifications.length === 0
            ) &&
            !finishedFetching
            ) {
            <pp-button
              ppStyle="secondary"
              (ppAction)="fetchMoreNotifications()"
              >
              {{ 'load_more' | ppTranslate }}
            </pp-button>
          }
        </div>
      </div>
    </section>
  }
</article>
